
import React, { useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../main.css";

function FactAndButtons() {

    const [randomIndex] = useState(Math.floor(Math.random() * 6));
    const randomFacts = useRef({
    fact0: "non-corrosive",
    fact1: "freeze-resistant to -35° F",
    fact2: "non-toxic",
    fact3: "biodegradable",
    fact4: "water soluble",
    fact5: "animal food grade safe",
    }); 
    
    return (
    <>
        <p className="text-center">
            Fun fact: Did you know that Beet Juice is{" "}
            {randomFacts.current[`fact${randomIndex}`]}?
        </p>
        <Row className="pt-3 pb-2">
            <Col md className="text-md-left text-center">
            {/* <Col sm={12} md={6}> */}
            </Col>
            <Col md className="text-md-left text-center">
            {/* <Col sm={12} md={6}> */}{" "}
            </Col>
        </Row>
    </>
    );
}


export default FactAndButtons;